import { FC } from 'react'

import { Role } from '../types'
import MenuItem from './menu-item'
import LandlordAreaIcon from '../../../../assets/icons/userbar-icons/usermenu-icons/layout.svg'
import BriefcaseIcon from '../../../../assets/icons/userbar-icons/usermenu-icons/briefcase.svg'
import MegaphoneIcon from '../../../../assets/icons/userbar-icons/usermenu-icons/megaphone.svg'
import BillsIcon from '../../../../assets/icons/userbar-icons/usermenu-icons/file-text.svg'
import PersonalDataIcon from '../../../../assets/icons/userbar-icons/usermenu-icons/id.svg'
import LogoutIcon from '../../../../assets/icons/userbar-icons/usermenu-icons/logout.svg'
import { NavigationTransport } from '../../../../transports/common/navigation-section-transport'
import { useTranslation } from '../../../../hooks/locale'
import { UserMenuContentContainer } from './user-menu-content-styles'

interface Props {
    navigation: NavigationTransport
    userRole: Role
    inquiryCount?: number
}

const UserMenuContent: FC<Props> = ({ userRole, inquiryCount, navigation }) => {
    const {
        logoutButton,
        userBookingsButton,
        guestProfileButton,
        guestInquiriesButton,
        landlordAreaButton,
        landlordProfileButton,
        landlordInquiriesButton,
        landlordListingsButton,
        landlordInvoicesButton,
    } = navigation

    const { t } = useTranslation()

    return userRole === Role.CUSTOMER ? (
        <UserMenuContentContainer>
            <MenuItem
                icon={LandlordAreaIcon}
                altText={t('layoutIconText')}
                title={landlordAreaButton.text}
                link={landlordAreaButton.url!}
            />
            <MenuItem
                icon={BriefcaseIcon}
                altText={t('briefcaseIconText')}
                title={`${landlordInquiriesButton.text}${inquiryCount ? ` [${inquiryCount}]` : ''}`}
                link={landlordInquiriesButton.url!}
            />
            <MenuItem
                icon={BriefcaseIcon}
                altText={t('briefcaseIconText')}
                title={userBookingsButton.text}
                link={userBookingsButton.url!}
            />
            <MenuItem
                icon={MegaphoneIcon}
                altText={t('megaphoneIconText')}
                title={landlordListingsButton.text}
                link={landlordListingsButton.url!}
            />
            <MenuItem
                icon={BillsIcon}
                altText={t('fileIconText')}
                title={landlordInvoicesButton.text}
                link={landlordInvoicesButton.url!}
            />
            <MenuItem
                icon={PersonalDataIcon}
                altText={t('idIconText')}
                title={landlordProfileButton.text}
                link={landlordProfileButton.url!}
            />
            <MenuItem
                icon={LogoutIcon}
                altText={t('logoutIconText')}
                title={logoutButton.text}
                link={logoutButton.url!}
            />
        </UserMenuContentContainer>
    ) : (
        <UserMenuContentContainer>
            <MenuItem
                icon={BriefcaseIcon}
                altText={t('briefcaseIconText')}
                title={`${guestInquiriesButton.text}${inquiryCount ? ` [${inquiryCount}]` : ''}`}
                link={guestInquiriesButton.url!}
            />
            <MenuItem
                icon={BriefcaseIcon}
                altText={t('briefcaseIconText')}
                title={userBookingsButton.text}
                link={userBookingsButton.url!}
            />
            <MenuItem
                icon={PersonalDataIcon}
                altText={t('idIconText')}
                title={guestProfileButton.text}
                link={guestProfileButton.url!}
            />
            <MenuItem
                icon={LogoutIcon}
                altText={t('logoutIconText')}
                title={logoutButton.text}
                link={logoutButton.url!}
            />
        </UserMenuContentContainer>
    )
}

export default UserMenuContent
